import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  public title: string = "Confirm?";
  public message: string = "Confirm this operation.";
  public yesLabel: string = "Yes";
  public noLabel: string = "No";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>)
  {
    if (data.title != null) this.title = data.title;

    if (data.message != null) this.message = data.message;

    if (data.yesLabel != null) this.yesLabel = data.yesLabel;

    if (data.noLabel != null) this.noLabel = data.noLabel;
  }

  ngOnInit(): void {
  }

  close(value: boolean) {
    this.dialogRef.close(value);
  }
}
